import React from 'react'
import Link from 'gatsby-link'
import '../style/footer.scss'
import Fade from 'react-reveal/Fade';
import Layout4 from '../images/layout4.png'
import Logo from '../images/white-orange.png'
import Heart from '../images/heart.svg'

const Header = ({siteTitle}) => (
  <div className="footer-container">
  <div className="column brand">
    <temp></temp>
    <img className="logo" src={Logo} alt="logo"></img>
    <temp></temp>
    <img className="layout4" src={Layout4} alt="layout"></img>
  </div>
  <temp></temp>

  <div className="column">
    <div className="footer-title">ADRESSE</div>
    <div className="footer-row">PLAGE DU SOUFFLEUR</div>
    <div className="footer-row">PORT-LOUIS, GUADELOUPE 97117</div>
  </div>
<temp></temp>
  <div className="column">
    <div className="footer-title">HORAIRES</div>
    <div className="footer-row">LUNDI AU DIMANCHE</div>
    <div className="footer-row">10H - 19H</div>
  </div>
<temp></temp>
  <div className="column">
    <div className="footer-title">CONTACT</div>
    <a className="footer-row phone" href="tel:0033695335509">MAX - +33695 335 509</a>
    <div className="footer-row">
      <a className='icon-phone icon' href="tel:0033695335509"></a>
      <a className='icon-mail icon' href="mailto:polwisurfcenter@gmail.com?subject=Réservation&bcc=mxmarianne@gmail.com&body=Bonjour, Je souhaiterais réserver ..."></a>
      <div className='icon-facebook icon' onClick={() => window.open("https://fb.me/SouffleurPolwi", "_blank")}></div>
      <div className='icon-youtube icon' onClick={() => window.open("https://youtu.be/f99bCywk5DA", "_blank")}></div>
    </div>
    <temp></temp>
    <a className="copyright" href="mailto:samyalexandre@hotmail.fr">
      <div>MADE WITH</div>
      <img className="heart" src={Heart} alt="heart"></img>
      <div>BY</div>
      <div className="myself">SAMY</div>
    </a>
  </div>
  <temp></temp>
</div>)

export default Header



// WEBPACK FOOTER //
// ./src/components/footer.js